export default "__VITE_ASSET__bWZ1gKgf__"